// extracted by mini-css-extract-plugin
export var quillEditor = "_p5-1";
export var variable = "_p5-0";